import React, { Children, FC, memo } from "react";
import {
  checkedCircleIcon,
  removeCircleIcon,
  warningCircleIcon,
} from "../../images/svgIcons";
import "./styles.scss";

const Message: FC<{ type: string; text?: any; Children?: any }> = ({
  type,
  text,
}) => (
  <div className={`message-block ${type}`}>
    <span className="icon">
      {type === "error"
        ? removeCircleIcon
        : type === "success"
        ? checkedCircleIcon
        : warningCircleIcon}
    </span>
    {Children ? (
      <span className="text mb-0">
        {text}
      </span>
    ) : (
      Children
    )}
  </div>
);

export default memo(Message);
